/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Geo_Label_PolynesiaInputs */

const bn_geo_label_polynesia = /** @type {(inputs: Geo_Label_PolynesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`পলিনেশিয়া`)
};

const de_geo_label_polynesia = /** @type {(inputs: Geo_Label_PolynesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polynesien`)
};

const el_geo_label_polynesia = /** @type {(inputs: Geo_Label_PolynesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Πολυνησία`)
};

const en_geo_label_polynesia = /** @type {(inputs: Geo_Label_PolynesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polynesia`)
};

const es_geo_label_polynesia = /** @type {(inputs: Geo_Label_PolynesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polinesia`)
};

const fr_geo_label_polynesia = /** @type {(inputs: Geo_Label_PolynesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polynésie`)
};

const hi_geo_label_polynesia = /** @type {(inputs: Geo_Label_PolynesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पोलिनेशिया`)
};

const hu_geo_label_polynesia = /** @type {(inputs: Geo_Label_PolynesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polinézia`)
};

const id_geo_label_polynesia = /** @type {(inputs: Geo_Label_PolynesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polinesia`)
};

const it_geo_label_polynesia = /** @type {(inputs: Geo_Label_PolynesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polinesia`)
};

const ja_geo_label_polynesia = /** @type {(inputs: Geo_Label_PolynesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ポリネシア`)
};

const ko_geo_label_polynesia = /** @type {(inputs: Geo_Label_PolynesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`폴리네시아`)
};

const nl_geo_label_polynesia = /** @type {(inputs: Geo_Label_PolynesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polynesië`)
};

const pl_geo_label_polynesia = /** @type {(inputs: Geo_Label_PolynesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polinezja`)
};

const pt_geo_label_polynesia = /** @type {(inputs: Geo_Label_PolynesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polinésia`)
};

const ru_geo_label_polynesia = /** @type {(inputs: Geo_Label_PolynesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полинезия`)
};

const sv_geo_label_polynesia = /** @type {(inputs: Geo_Label_PolynesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polynesien`)
};

const tr_geo_label_polynesia = /** @type {(inputs: Geo_Label_PolynesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polinezya`)
};

const uk_geo_label_polynesia = /** @type {(inputs: Geo_Label_PolynesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полінезія`)
};

const vi_geo_label_polynesia = /** @type {(inputs: Geo_Label_PolynesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Polynesia`)
};

const zh_geo_label_polynesia = /** @type {(inputs: Geo_Label_PolynesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`波利尼西亚`)
};

const zh_hant_geo_label_polynesia = /** @type {(inputs: Geo_Label_PolynesiaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`波利尼西亞`)
};

/**
* | output |
* | --- |
* | "Polynesia" |
*
* @param {Geo_Label_PolynesiaInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const geo_label_polynesia = /** @type {((inputs?: Geo_Label_PolynesiaInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Geo_Label_PolynesiaInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_geo_label_polynesia(inputs)
	if (locale === "de") return de_geo_label_polynesia(inputs)
	if (locale === "el") return el_geo_label_polynesia(inputs)
	if (locale === "en") return en_geo_label_polynesia(inputs)
	if (locale === "es") return es_geo_label_polynesia(inputs)
	if (locale === "fr") return fr_geo_label_polynesia(inputs)
	if (locale === "hi") return hi_geo_label_polynesia(inputs)
	if (locale === "hu") return hu_geo_label_polynesia(inputs)
	if (locale === "id") return id_geo_label_polynesia(inputs)
	if (locale === "it") return it_geo_label_polynesia(inputs)
	if (locale === "ja") return ja_geo_label_polynesia(inputs)
	if (locale === "ko") return ko_geo_label_polynesia(inputs)
	if (locale === "nl") return nl_geo_label_polynesia(inputs)
	if (locale === "pl") return pl_geo_label_polynesia(inputs)
	if (locale === "pt") return pt_geo_label_polynesia(inputs)
	if (locale === "ru") return ru_geo_label_polynesia(inputs)
	if (locale === "sv") return sv_geo_label_polynesia(inputs)
	if (locale === "tr") return tr_geo_label_polynesia(inputs)
	if (locale === "uk") return uk_geo_label_polynesia(inputs)
	if (locale === "vi") return vi_geo_label_polynesia(inputs)
	if (locale === "zh") return zh_geo_label_polynesia(inputs)
	return zh_hant_geo_label_polynesia(inputs)
});